import React from 'react';
import { CtaButton } from './CtaButton';
interface PriceCtaProps {
  variant?: 'light' | 'dark';
}
export function PriceCta({
  variant = 'light'
}: PriceCtaProps) {
  const labelColor = variant === 'dark' ? 'text-bone/60' : 'text-ink-light';
  const oldPriceColor = variant === 'dark' ? 'text-bone/40' : 'text-ink/40';
  const priceColor = variant === 'dark' ? 'text-bone' : 'text-ink';
  return <div data-id="element-173">
      <div className="flex items-baseline justify-center md:justify-start gap-3 mb-4" data-id="element-174">
        <span className={`text-sm font-sans uppercase tracking-widest ${labelColor}`} data-id="element-175">
          Precio hoy
        </span>
        <span className={`text-base line-through font-sans ${oldPriceColor}`} data-id="element-176">
          $39.990
        </span>
      </div>
      <div className="flex items-baseline justify-center md:justify-start gap-2 mb-6" data-id="element-177">
        <span className={`text-5xl md:text-6xl font-serif font-semibold leading-none ${priceColor}`} data-id="element-178">
          $19.990
        </span>
        <span className={`text-base font-sans ${labelColor}`} data-id="element-179">ARS</span>
      </div>
      <CtaButton fullWidth className="text-lg" data-id="element-180">
        🛑 QUIERO MI MENTE RESUELTA AHORA — $19.990
      </CtaButton>
      <p className={`mt-3 text-xs font-sans ${labelColor} text-center md:text-left`} data-id="element-181">
        Pago único · Acceso inmediato al PDF
      </p>
    </div>;
}